import { render } from "./DataFormatting.vue?vue&type=template&id=7fdabbfa&scoped=true"
import script from "./DataFormatting.vue?vue&type=script&lang=js"
export * from "./DataFormatting.vue?vue&type=script&lang=js"

import "./DataFormatting.vue?vue&type=style&index=0&id=7fdabbfa&lang=scss&scoped=true"

import exportComponent from "/Users/fredericfox/Library/Mobile Documents/com~apple~CloudDocs/VS Code/Vue Coding Projects/vue-pinky/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fdabbfa"]])

export default __exports__